// components/RequestAccessModal.js
import React, { useState } from 'react';
import { FiX, FiClock, FiSend } from 'react-icons/fi';
import supabase from '../services/supabase';
import { useAuth } from '../services/auth';
import '../styles/Modals.scss';

const RequestAccessModal = ({ eventId, financialYear, eventTitle, onClose, onRequested }) => {
  const { user } = useAuth();
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!message.trim()) {
      setError('Please enter a message');
      return;
    }

    setError(null);
    setSubmitting(true);

    try {
      const { error: insertError } = await supabase
        .from('event_access_requests')
        .insert({
          event_id: eventId,
          financial_year: financialYear,
          user_id: user.id,
          message: message.trim(),
          status: 'pending',
        });

      if (insertError) throw insertError;

      onRequested();
      alert('Access request submitted! The host will review your request.');
    } catch (error) {
      console.error('Request error:', error);
      setError('Failed to submit request. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content request-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <FiX />
        </button>

        <div className="modal-icon">
          <FiClock size={48} />
        </div>

        <h2>Request Access</h2>
        <p className="modal-subtitle">
          This event requires approval. Tell the host why you'd like to attend.
        </p>

        <div className="form-group">
          <label>Message to Host</label>
          <textarea
            placeholder="Hi! I'd love to attend your event..."
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setError(null);
            }}
            maxLength={500}
            rows={4}
          />
          <div className="char-count">
            {message.length}/500
          </div>
          {error && <p className="error-text">{error}</p>}
        </div>

        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={!message.trim() || submitting}
        >
          {submitting ? (
            'Sending...'
          ) : (
            <>
              <FiSend /> Send Request
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default RequestAccessModal;